import { render, staticRenderFns } from "./CheckSyncResultForgot.vue?vue&type=template&id=7cb37c0b&scoped=true&"
import script from "./CheckSyncResultForgot.vue?vue&type=script&lang=ts&"
export * from "./CheckSyncResultForgot.vue?vue&type=script&lang=ts&"
import style0 from "./CheckSyncResultForgot.vue?vue&type=style&index=0&id=7cb37c0b&lang=scss&scoped=true&"
import style1 from "./CheckSyncResultForgot.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb37c0b",
  null
  
)

export default component.exports